import axios from "axios";
import { useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";

const fetchCategories = async () => {
  return await axios.get(API_URL + `/api/News/GetCategories`, {
    headers: securityHeaders,
  });
};

export const useFetchCategories = () => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: () => fetchCategories(),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};
